const { Random } = require('mockjs')
const tokens = {
  admin: `admin-token-${Random.guid()}`,
  editor: `editor-token-${Random.guid()}`,
  test: `test-token-${Random.guid()}`,
}

module.exports = [
  {
    url: '/app/findToken',
    type: 'get',
    response() {
      return {
        code: 200,
        msg: 'token',
      }
    },
  },
  {
    url: '/app/signIn',
    type: 'post',
    response(config) {
      const { customId } = config.body
      const token = tokens[customId]
      if (!token)
        return {
          code: 500,
          msg: '帐户或密码不正确',
        }
      return {
        code: 200,
        msg: 'success',
        data: { token },
      }
    },
  },
  {
    url: '/register',
    type: 'post',
    response() {
      return {
        code: 200,
        msg: '模拟注册成功',
      }
    },
  },
  {
    url: '/userInfo',
    type: 'get',
    response(config) {
      const authorization =
        config.headers.authorization || config.headers.Authorization
      let roles = ['admin']
      let ability = ['READ']
      let username = 'admin'
      if (authorization.includes('admin-token')) {
        roles = ['admin']
        ability = ['READ', 'WRITE', 'DELETE']
        username = 'admin'
      }
      if (authorization.includes('editor-token')) {
        roles = ['editor']
        ability = ['READ', 'WRITE']
        username = 'editor'
      }
      if (authorization.includes('test-token')) {
        roles = ['admin', 'editor']
        ability = ['READ']
        username = 'test'
      }
      return {
        code: 200,
        msg: 'success',
        data: {
          roles,
          ability,
          username,
          avatar: 'https://i.gtimg.cn/club/item/face/img/2/16022_100.gif',
        },
      }
    },
  },
  {
    url: '/logout',
    type: 'get',
    response() {
      return {
        code: 200,
        msg: 'success',
      }
    },
  },
]
